import { render, staticRenderFns } from "./reputation.vue?vue&type=template&id=c65ddf56"
import script from "./reputation.vue?vue&type=script&lang=js"
export * from "./reputation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports